import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: all;\n    padding: 20px 0;\n    max-height: 100vh;\n    overflow: auto;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    overflow: hidden;\n    pointer-events: none;\n    background-position: center center;\n    background-size: cover;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import { useStep } from '../../hooks/useStep';
import { ConfigContext } from '../../lib/Config';
import { SubSteps } from '../SubSteps';
import { trail, set, fromTo, val, parallel } from 'light-trails';
const inactiveZIndex = 1;
const activeZIndex = 2;
export const Slide = props => {
  const baseConfig = useContext(ConfigContext);

  const config = _objectSpread({}, baseConfig, {}, props.config);

  const contentRef = useRef(null);
  const backgroundRef = useRef(null);
  useStep(props.start === 1 ? undefined : props.start, // Skip first slide enter animation
  ({
    duration
  }) => {
    const contentFrames = trail(contentRef.current, [set({
      zIndex: [undefined, inactiveZIndex]
    }), fromTo({
      opacity: val(0, 1),
      scale: val(0.8, 1)
    }, duration.slow), set({
      zIndex: [inactiveZIndex, activeZIndex]
    })]);
    const bgFrames = trail(backgroundRef.current, [fromTo({
      opacity: val(0, 1)
    }, duration.slow)]);
    return parallel([contentFrames, bgFrames]);
  }, {
    title: '→Slide',
    animateWithNext: true
  });
  useStep(-props.start, ({
    duration
  }) => {
    const contentFrames = trail(contentRef.current, [fromTo({
      opacity: val(1, 0),
      x: val(0, -100, '%')
    }, duration.slow), set({
      zIndex: [activeZIndex, inactiveZIndex]
    })]);
    const bgFrames = trail(backgroundRef.current, [fromTo({
      opacity: val(1, 0)
    }, duration.slow)]);
    return parallel([contentFrames, bgFrames]);
  }, {
    title: '←Slide'
  });
  return React.createElement(SubSteps, {
    start: props.start,
    unwrap: props.unwrap
  }, React.createElement(Background, {
    ref: backgroundRef,
    style: {
      backgroundColor: config.backgroundColor,
      backgroundImage: "url(".concat(config.backgroundImage, ")")
    }
  }, React.createElement(Content, {
    ref: contentRef,
    style: {
      zIndex: inactiveZIndex
    }
  }, React.createElement("div", null, props.children))));
};
const Background = styled.div(_templateObject());
const Content = styled.div(_templateObject2());